import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  userEntersFirstName,
  UserEntersFirstName,
  userEntersLastName,
  UserEntersLastName
} from '../actions/Actions';
import { IState, IUserInfo } from '../CustomTypes';
import { validateName } from '../validators';
import './Name.scss';

export interface IActionProps {
  userEntersFirstName: UserEntersFirstName;
  userEntersLastName: UserEntersLastName;
}

export interface IParamProps {
  initialFocus?: boolean;
  formSubmitted?: boolean;
  spacing?: boolean;
}

export interface IStateProps {
  userInfo: IUserInfo;
}

export interface IProps extends IParamProps, IStateProps, IActionProps {}

export class Name extends React.Component<
  IProps,
  { showValidationError: boolean }
> {
  constructor(props: IProps) {
    super(props);
    this.onBlur = this.onBlur.bind(this);
    this.isValid = this.isValid.bind(this);
    this.state = { showValidationError: false };
  }

  public render() {
    const { firstName, lastName } = this.props.userInfo;
    const { initialFocus, formSubmitted, spacing } = this.props;
    const validationErrorMessage =
      'Vennligst oppgi et gyldig navn. Du kan kun bruke bokstaver, tall og mellomrom.';

    const validationCorrectClass = this.isValid() ? '  validationCorrect' : '';

    const showValidationError =
      (formSubmitted || this.state.showValidationError) && !this.isValid();
    const validationErrorClass = showValidationError ? ' validationError' : '';

    return (
      <div className="nameinput row">
        <div className="inputField form-group">
          <div className={'col-xs-6 ' + (spacing ? '' : 'firstNameNoSpacing')}>
            <div
              className={`inputField  ${validationCorrectClass} ${validationErrorClass}`}
            >
              <input
                id="firstName"
                value={firstName}
                autoFocus={initialFocus}
                type="text"
                className="form-control"
                onChange={e =>
                  this.props.userEntersFirstName(e.currentTarget.value)
                }
                placeholder="Fornavn"
                maxLength={200}
              />
              <label htmlFor="firstName">
                Navn
                {this.isValid() && (
                  <span className="icon ion-checkmark-round" />
                )}
                {showValidationError && (
                  <span className="icon ion-information-circled" />
                )}
              </label>
            </div>
          </div>
          <div className={'col-xs-6 ' + (spacing ? '' : 'lastNameNoSpacing')}>
            <div
              className={`inputField  ${validationCorrectClass}  ${validationErrorClass}`}
            >
              <input
                id="lastName"
                value={lastName}
                type="text"
                className="form-control"
                onChange={e =>
                  this.props.userEntersLastName(e.currentTarget.value)
                }
                placeholder="Etternavn"
                maxLength={200}
                onBlur={this.onBlur}
              />
              {spacing && (
                <label htmlFor="lastName">
                  Etternavn
                  {this.isValid() && (
                    <span className="icon ion-checkmark-round" />
                  )}
                  {showValidationError && (
                    <span className="icon ion-information-circled" />
                  )}
                </label>
              )}
            </div>
          </div>
          {showValidationError && (
            <div className="col-xs-12 validationErrorMessage">
              {validationErrorMessage}
            </div>
          )}
        </div>
      </div>
    );
  }

  private onBlur() {
    this.setState({ showValidationError: !this.isValid() });
  }

  private isValid(): boolean {
    const { firstName, lastName } = this.props.userInfo;
    return validateName(firstName) && validateName(lastName);
  }
}

export default connect(
  (state: IState) =>
    ({
      userInfo: state.userInfo
    } as IStateProps),
  dispatch =>
    bindActionCreators(
      {
        userEntersFirstName,
        userEntersLastName
      },
      dispatch
    ) as IActionProps
)(Name);



// WEBPACK FOOTER //
// ./src/input-components/Name.tsx